import { AnyComparator, CompleteCondition, DefaultComparator } from 'modules/queryBuilder/types';
import { UNSUBSCRIBED_MESSAGE_TYPE_REPLACEMENT_FEATURE_FLAG } from 'modules/queryBuilder/featureFlags';
import { SUBSCRIBED_MESSAGE_TYPES, UNSUBSCRIBED_MESSAGE_TYPES } from 'utils/fieldConstants';
import { useFeatureFlag } from 'utils/hooks/useFeatureFlag';

const getSubscribedMessageTypeComparator = (comparatorType: AnyComparator) => {
  if (comparatorType === DefaultComparator.EQUALS) return DefaultComparator.DOES_NOT_EQUAL;
  else if (comparatorType === DefaultComparator.DOES_NOT_EQUAL) return DefaultComparator.EQUALS;
  else return comparatorType;
};

export const useConvertToSubscribedMessageCondition = () => {
  const isFeatureFlagged = useFeatureFlag(
    UNSUBSCRIBED_MESSAGE_TYPE_REPLACEMENT_FEATURE_FLAG,
    false,
  );

  return (condition: CompleteCondition) => {
    return isFeatureFlagged && condition.field === UNSUBSCRIBED_MESSAGE_TYPES
      ? {
          ...condition,
          field: SUBSCRIBED_MESSAGE_TYPES,
          comparatorType: getSubscribedMessageTypeComparator(condition.comparatorType),
        }
      : condition;
  };
};
